// Libraries
import React from 'react';

// Supermove
import {Styled, Space} from '@supermove/components';
import {Stage} from '@supermove/models';
import {colors, Typography} from '@supermove/styles';

// App
import DropdownInput from '@shared/design/components/DropdownInput';
import FieldInput from '@shared/design/components/Field/FieldInput';
import {StageFormType} from '@shared/modules/Project/forms/StageForm';

const Row = Styled.View`
  flex-direction: row;
  align-items: center;
`;

const OptionText = Styled.Text`
  ${Typography.Body3}
`;

const ColorDot = Styled.View<{color: string}>`
  height: 14px;
  width: 14px;
  border-radius: 14px;
  background-color: ${({color}) => color};
`;

const ColorOption = ({isSelected, value, label}: any) => {
  return (
    <Row>
      <ColorDot color={value} />
      <Space width={8} />
      <OptionText style={{color: isSelected ? colors.white : colors.black}}>{label}</OptionText>
    </Row>
  );
};

interface EditStageFieldsProps {
  form: StageFormType;
}

const EditStageFields = ({form}: EditStageFieldsProps) => {
  const field = 'stageForm';
  return (
    <React.Fragment>
      <FieldInput
        {...form}
        index={4}
        label={'Name'}
        name={`${field}.name`}
        isResponsive
        isRequired
        input={{
          setFieldValue: form.setFieldValue,
          placeholder: 'E.g. Quote Pending',
        }}
      />
      <Space height={16} />
      <FieldInput
        {...form}
        index={4}
        label={'Description'}
        name={`${field}.description`}
        isResponsive
        input={{
          setFieldValue: form.setFieldValue,
          placeholder: `E.g. Awaiting the customer's response to the provided quote. Follow up as needed to move the lead forward.`,
          multiline: true,
          style: {minHeight: 124, paddingTop: 8},
        }}
      />
      <Space height={16} />
      <FieldInput
        {...form}
        name={`${field}.color`}
        label={'Color'}
        component={DropdownInput}
        isResponsive
        style={{flex: 1}}
        isRequired
        input={{
          showDescriptionInOption: true,
          placeholder: 'Select color',
          style: {flex: 1},
          isPortaled: true,
          options: Stage.getColorSelectorDropdownOptions(),
          isColorOptions: true,
          setFieldValue: form.setFieldValue,
        }}
      />
    </React.Fragment>
  );
};

export default EditStageFields;
